export type CancellablePromise = {
	promise: Promise<any>,
	cancel: Function
}

const makeCancellablePromise = (child:Promise<any>, callback?:Function):CancellablePromise => {
	let cancelled = false;

	const wrapper = new Promise((resolve, reject) => {
		child.then(
			response => cancelled ? reject({cancelled: true}) : resolve(response),
			error => cancelled ? reject({cancelled: true}) : reject(error),
		);
	}).then(
		response => callback ? callback(response) : response
	);

	return {
		promise: wrapper,
		cancel: () => cancelled = true
	}
}

export default makeCancellablePromise;